export default "__VITE_ASSET__D_5U7QIh__"